import {
  Clock01Icon,
  GridViewIcon,
  SquareLock02Icon,
  PlayCircleIcon,
  StarIcon,
  Tick02Icon
} from '@hugeicons/react'
import type { ReactNode } from 'react'

import type { FilterChipOption } from '@/shared/ui/Layout/page/FilterChips'

import { JOURNEY_FILTERS, type JourneyFilterId } from '../constants/status'

/* `Partial`: nem toda opção precisa de ícone. */
const JOURNEY_FILTER_ICONS: Partial<Record<JourneyFilterId, ReactNode>> = {
  all: <GridViewIcon size={12} variant="stroke" aria-hidden />,
  progress: (
    <Clock01Icon size={12} variant="stroke" style={{ color: '#ff9800' }} aria-hidden />
  ),
  /* A estrela saiu de `available` e foi para `new`: ela sinaliza novidade, e
     enquanto marcava disponibilidade carimbava todo item liberado desde o
     primeiro minuto do evento. */
  available: (
    <PlayCircleIcon
      size={12}
      variant="stroke"
      style={{ color: 'var(--color-brand)' }}
      aria-hidden
    />
  ),
  new: (
    <StarIcon
      size={12}
      variant="duotone"
      style={{ color: 'var(--color-brand)' }}
      aria-hidden
    />
  ),
  success: (
    <Tick02Icon size={12} variant="stroke" style={{ color: '#22c55e' }} aria-hidden />
  ),
  locked: (
    <SquareLock02Icon size={12} variant="stroke" style={{ color: 'var(--color-gray-600)' }} aria-hidden />
  )
}

/* `new` entra aqui e não em `JOURNEY_FILTERS` porque não é `ResourceStatus` — o
   vocabulário canônico não o conhece. Fica logo após "Todas", e a regra de
   visibilidade garante que só apareça havendo item dentro da janela de 1h. */
const OPTIONS: { id: JourneyFilterId; label: string }[] = [
  JOURNEY_FILTERS[0],
  { id: 'new', label: 'Novas' },
  ...JOURNEY_FILTERS.slice(1)
]

export const JOURNEY_FILTER_OPTIONS: FilterChipOption<JourneyFilterId>[] =
  OPTIONS.map(filter => ({
    ...filter,
    icon: JOURNEY_FILTER_ICONS[filter.id]
  }))
